function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  className: "path",
  fill: "none",
  cx: 33,
  cy: 33,
  r: 30
});

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "spinner",
    width: "65px",
    height: "65px",
    viewBox: "0 0 66 66"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Spinner.8b866cd9.svg";
export { SvgSpinner as ReactComponent };